import React from 'react'
import { withMapInitialized } from '../map.utils'
import s from './AddressMarker.less'
import ImageMarker from './ImageMarker'
import Marker from './Marker'
import greyMarker from './marker-grey.png'
import { ADDRESS_BIG_MARKER_HEIGHT, ADDRESS_BIG_MARKER_WIDTH } from './Marker.constants'

const AddressMarker = ({ coordinates, onClick }) => (
  <Marker coordinates={coordinates} onClick={onClick} cssClasses={s.addressMarker}>
    <ImageMarker src={greyMarker} width={ADDRESS_BIG_MARKER_WIDTH} height={ADDRESS_BIG_MARKER_HEIGHT} />
  </Marker>
)

export default withMapInitialized(AddressMarker)
